/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import ViewModel from "../../ViewModels/ViewModel";
import CommandBarMenuProps from "./CommandBarMenuProps";
import CommandBarMenuState from "./CommandBarMenuState";

export default class CommandBarMenuModel extends ViewModel<CommandBarMenuState> {
    public constructor(private readonly _props: CommandBarMenuProps) {
        super({
            initialState: { anchorElement: undefined },
        });
    }

    public get anchorElement(): HTMLButtonElement | undefined {
        return this.state.anchorElement;
    }

    public get isOpen(): boolean {
        return Boolean(this.state.anchorElement);
    }

    public oeffneMenu = (e: React.MouseEvent<HTMLButtonElement>) => {
        this.setState((nextState) => (nextState.anchorElement = e.currentTarget));
    };

    public schliesseMenu = () => {
        this.setState((nextState) => (nextState.anchorElement = undefined));
    };
}
